import React, { ChangeEvent, forwardRef, ReactNode } from "react";
import classNames from "classnames";

import "./styles.css";

export type RadioOption = {
  label: ReactNode;
  value: string | number;
  disabled?: boolean;
};

type Props = {
  options: RadioOption[];
  orientation?: "horizontal" | "vertical";
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  name?: string;
  disabled?: boolean;
  className?: string;
  checked?: string | number;
  containerClassName?: string;
  optionContainerClassName?: string;
  value?: string | number;
};

export const Radio = forwardRef<HTMLInputElement, Props>(
  (
    {
      options,
      orientation = "horizontal",
      checked,
      onChange,
      name = "",
      disabled = false,
      className = "",
      containerClassName = "",
      optionContainerClassName = "",
      value: defaultValue,
      ...rest
    },
    ref
  ) => {
    return (
      <div
        className={classNames(
          "flex gap-x-5",
          orientation === "horizontal" ? "flex-row" : "flex-col",
          containerClassName
        )}
      >
        {options.map(({ label, value, disabled: optDisabled }, index) => (
          <div
            key={`${name}-${index}`}
            className={classNames(
              "flex items-center",
              optionContainerClassName
            )}
          >
            <label
              className={classNames(
                "inline-flex items-center space-x-3 cursor-pointer gap-4",
                { "theme-text-secondary": disabled || optDisabled }
              )}
            >
              <input
                {...rest}
                name={name}
                onChange={onChange}
                type="radio"
                disabled={disabled || optDisabled}
                className={classNames(
                  "custom-radio appearance-none bg-white bg-check h-8 w-8 border border-solid theme-border rounded-full cursor-pointer flex-shrink-0",
                  className
                )}
                value={value}
                checked={value.toString() === checked?.toString()}
                ref={ref}
              />
              {label}
            </label>
          </div>
        ))}
      </div>
    );
  }
);
